export default "__VITE_ASSET__Br8APIv2__"